import { Collapse, List, ListItem, ListItemText } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { FC } from 'react'
import WikiContentComponent, { WikiContent } from '../wikicontent/WikiContent'
import { wikiSectionStyle } from './WikiSection.style'

/**
 * Object type describing a Section of a WikiDocument
 */
export interface WikiSection {
  id: string
  title: string
  content: WikiContent[]
}

/**
 * WikiSectionComponentProps contains properties for the component.
 */
export interface WikiSectionComponentProps {
  section: WikiSection
  open: boolean
  onClick: (sectionId: string) => void
}

/**
 * WikiSectionComponent displays a section from a WikiDocument
 * @param props Properties for component.
 * @returns JSX component.
 */
export const WikiSectionComponent: FC<WikiSectionComponentProps> = (props: WikiSectionComponentProps) => {
  const classes = wikiSectionStyle()

  return (
    <>
      <List
        component='nav'
        aria-labelledby='nested-list-subheader'
        className={classes.list}
      >
        <ListItem
          button
          onClick={() => { props.onClick(props.section.id) }}
          className={classes.sectionListItem}
        >
          <ListItemText primary={props.section.title} className={classes.title} />
          {props.open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <div className={classes.content}>
          <Collapse in={props.open} timeout='auto'>
            {props.section.content.map((content, index) => {
              return (
                <div key={index}>
                  <ListItem className={classes.contentListItem}>
                    <WikiContentComponent content={content} />
                  </ListItem>
                </div>
              )
            })}
          </Collapse>
        </div>
      </List>
    </>
  )
}

export default WikiSectionComponent
